__turbopack_context__.v({
  "bulletsContainer": "CityDetailReviews-module-scss-module__me7WhW__bulletsContainer",
  "closeButton": "CityDetailReviews-module-scss-module__me7WhW__closeButton",
  "closeButtonContainer": "CityDetailReviews-module-scss-module__me7WhW__closeButtonContainer",
  "ctaButton": "CityDetailReviews-module-scss-module__me7WhW__ctaButton",
  "ctaContainer": "CityDetailReviews-module-scss-module__me7WhW__ctaContainer",
  "cus_btn": "CityDetailReviews-module-scss-module__me7WhW__cus_btn",
  "header_container": "CityDetailReviews-module-scss-module__me7WhW__header_container",
  "iframeContainer": "CityDetailReviews-module-scss-module__me7WhW__iframeContainer",
  "nextArrow": "CityDetailReviews-module-scss-module__me7WhW__nextArrow",
  "prevArrow": "CityDetailReviews-module-scss-module__me7WhW__prevArrow",
  "readMoreBtn": "CityDetailReviews-module-scss-module__me7WhW__readMoreBtn",
  "reviewBody": "CityDetailReviews-module-scss-module__me7WhW__reviewBody",
  "reviewHead": "CityDetailReviews-module-scss-module__me7WhW__reviewHead",
  "reviewText": "CityDetailReviews-module-scss-module__me7WhW__reviewText",
  "reviewerDegree": "CityDetailReviews-module-scss-module__me7WhW__reviewerDegree",
  "reviewerDetails": "CityDetailReviews-module-scss-module__me7WhW__reviewerDetails",
  "reviewerImg": "CityDetailReviews-module-scss-module__me7WhW__reviewerImg",
  "reviewerName": "CityDetailReviews-module-scss-module__me7WhW__reviewerName",
  "reviewsCarouselWrapper": "CityDetailReviews-module-scss-module__me7WhW__reviewsCarouselWrapper",
  "reviewsOnlineContainer": "CityDetailReviews-module-scss-module__me7WhW__reviewsOnlineContainer",
  "reviewsOnlineDesc": "CityDetailReviews-module-scss-module__me7WhW__reviewsOnlineDesc",
  "reviewsOnlineItem": "CityDetailReviews-module-scss-module__me7WhW__reviewsOnlineItem",
  "reviewsOnlineTitle": "CityDetailReviews-module-scss-module__me7WhW__reviewsOnlineTitle",
  "sc_btn": "CityDetailReviews-module-scss-module__me7WhW__sc_btn",
  "slideWrapper": "CityDetailReviews-module-scss-module__me7WhW__slideWrapper",
  "stars": "CityDetailReviews-module-scss-module__me7WhW__stars",
  "textReviewContainer": "CityDetailReviews-module-scss-module__me7WhW__textReviewContainer",
  "text_caru_container": "CityDetailReviews-module-scss-module__me7WhW__text_caru_container",
  "videoModalBox": "CityDetailReviews-module-scss-module__me7WhW__videoModalBox",
  "videoModalContainer": "CityDetailReviews-module-scss-module__me7WhW__videoModalContainer",
  "videoModalContent": "CityDetailReviews-module-scss-module__me7WhW__videoModalContent",
});
